import { render, staticRenderFns } from "./CNoDataInfo.vue?vue&type=template&id=b1c61e7a&scoped=true"
import script from "./CNoDataInfo.vue?vue&type=script&lang=ts"
export * from "./CNoDataInfo.vue?vue&type=script&lang=ts"
import style0 from "./CNoDataInfo.vue?vue&type=style&index=0&id=b1c61e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c61e7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
